export class Roles{
    public static Employee : string = 'idi_employee';
}

export class SessionManagement {
    public static IsAuthenticated :string = 'idi.isAuthenticated';
    public static UserProfile :string = 'idi.userProfile';
    public static Token :string = 'idi.token';
}